import ModelEntity from "../../model2/model-entity";
import ErrorProto from "../../gd/validation/error";
import {ErrorType} from "../../gd/validation/error-type";
import ErrorFieldRequired from "../../gd/validation/error-field-required";
import FormFieldError from "./form-error/form-field-error";

// const debug = {
//     dev: false,
//     trace: false,
//     validation      : false,
//     fieldValidation : false,
//     componentsRegister: false,
//     change: false,
//     head: "&& FormManager"
// };


/*
How validation works

form.showErrors = false by default (or set to true)
form.isValid = calculate ->

user updates form
    do nothing because showError = false ?

submit()
    event we run validate form

    form showErrors = true

fieldUpdate
    validateFields()
    showErrors()


 */

const debug = false //"FormModel"
const debugComponentsRegister   = false
const debugValueChange          = false
const debugSubmit               = false
const debugValidation           = false
const debugErrors               = false

// const debug                     = true //"FormModel"
// const debugComponentsRegister   = true
// const debugValueChange          = true
// const debugSubmit               = true
// const debugValidation           = true
// const debugErrors               = true

export type FormModelConfig = {
    // fields          : any
    onSubmit?       : callback
    onFormChanged?  : onChangeCallback
    validator?      : functionBoolean
    isFormChanged?  : boolean               // ?
}

export default class FormModel {

    public model            : ModelEntity

    private fieldComponents         : { [fieldId: string] : any}   = {}
    private errorComponents         : { [fieldId: string] : FormFieldError }   = {}
    private onFieldChangedCallbacks : { [fieldId: string] : callback }   = {}

    public fields           : any

    public onSubmit         : callback | null
    public onFormChanged?   : onChangeCallback
    public validator        : functionBoolean | null

    public isSubmitting     : boolean   = false
    public buttonSubmit     : any   = null
    private submitButtonComponent       : any | null   = null

    public validateBeforeSubmit   : boolean   = false       // if set to true force validation before submit


    // Validation
    public isFormChanged    : boolean   = false     // true once form has changed


    private errors          : ErrorProto[] | null   = null      // here we store all form errors
    public displayErrors    : boolean   = false



    constructor(model : ModelEntity, formConfig: FormModelConfig) {

        this.model  = model

        this.onSubmit       = formConfig.onSubmit || null
        this.onFormChanged  = formConfig.onFormChanged;

        this.validate();

        this.validator      = _.get(formConfig, 'validator' , null)

    }

    validateFields() {
        // _.forEach(this.fields, field => field.isValid = this.isFieldValid(field));
        // this.isFormValid = this._isFormValid();
    }

    private validate():void {

        let isValid : boolean = true;

        debugValidation && console.log("validateModel()", this.model);

        this.errors  = this.model.validate()

        // console.log("errors=", this.errors)


        // OLD
        // // check if all fields are valid...
        // _.forEach(this.fields, function (field, name) {
        //     if (!field.isValid) {
        //         if (debug.validation) console.log("        ", name, "- NOT valid");
        //         isValid = false;
        //     } else {
        //         if (debug.validation) console.log("        ", name, "- valid");
        //     }
        // });
        //
        // // run custom validator
        // if (isValid && this.validator) isValid = this.validator();
        // //todo ...

        // if (debug.validation) console.log("._isFormValid result=", isValid);
        //
        // if (debug.validation) console.groupEnd();


        // return isValid;
    }

    // validateForm(options:any={}):boolean {
    //
    //     if (debugValidation) console.log(".validate form");
    //
    //     const oldIsFormValid = this.isFormValid;
    //     const newIsFormValid = true //this._isFormValid();
    //
    //     if (debugValidation) console.log("... validate form result=", newIsFormValid," old result=",oldIsFormValid);
    //
    //     if (newIsFormValid != oldIsFormValid) {
    //         this.isFormValid = newIsFormValid;
    //         if (!options || !options.silent) this.renderSubmitButton();
    //     }
    //
    //     return newIsFormValid;
    //
    // }

    submit() {
        this.isSubmitting = true;
        if (this.buttonSubmit)
            this.buttonSubmit.setIsBusy(true);
    }


    // VALUES

    getValue(fieldId:string):any {
        // @ts-ignore
        const value = this.model[fieldId]

        // debug && console.log(debug, "getValue fieldId=", fieldId, "value=", value)
        return value
    }

    // setValue(name:string, newVal:any, options:any={}) {
    //     this.setFieldValue(name, newVal, options);
    // }

    // resetValues(values : any) {
    //
    //     debug && console.log(debug, "resetValues()")
    //
    //     _.forEach(values,  (value:any, name:string) => {
    //
    //         if (!this.fields[name]) {
    //             console.warn("unknow for field", name);
    //             return;
    //         }
    //
    //         if (this.fields[name].value != value) {
    //             this.fields[name].value = value;
    //
    //             this.fields[name].isValid = this.isFieldValid(this.fields[name])
    //         }
    //
    //     })
    //
    //     this.isFormValid = this._isFormValid();
    // }

    // if reRender false we'll update nothing
    reset(isFormChanged : boolean=false, reRender :boolean =true) {

        // this.isFormValid = true //this._isFormValid();
        this.isSubmitting = false;
        this.isFormChanged = (isFormChanged) ? isFormChanged : false;
        this.displayErrors = false;

        if (reRender) this.renderSubmitButton();
    }

    resetSubmit() {
        this.isSubmitting = false;
        this.renderSubmitButton();
    }

    formChanged() {

        if (debug) console.log(debug, ".formChanged");

        this.isFormChanged = true;
        this.renderSubmitButton();

        if (this.onFormChanged) this.onFormChanged(this.model);
    }


    // REGISTER COMPONENTS

    public registerFormComponent(fieldId:string, component:any):void {
        debugComponentsRegister && console.log(".registerFormComponent", fieldId, component);

        this.fieldComponents[fieldId]  = component;
    }

    public registerErrorComponent(fieldId:string, component:any):void {
        debugComponentsRegister && console.log(".registerErrorComponent", fieldId, component);
        this.errorComponents[fieldId] = component;
    }

    public unRegisterErrorComponent(fieldId:any):void {
        debugComponentsRegister && console.log(".unRegisterErrorComponent", name);

        if (!this.errorComponents[fieldId]) {
            console.warn("WARNING #99dddd83 - no field found", fieldId)
            return
        }

        delete this.errorComponents[fieldId]
    }

    public registerSubmitButton(component:any):void {
        debugComponentsRegister && console.log(".registerSubmitButton()", component);
        this.submitButtonComponent = component;
    }

    // EVENT HANDLERS

    // this is called by form element but ay be called manually when needed to
    public onFormComponentValueChange(fieldId:string, newValue:any) {
        debugValueChange && console.log("onFormComponentValueChange", fieldId, newValue)

        // const currentValue = this.getValue(fieldId)

        if (this.getValue(fieldId) != newValue || typeof newValue === 'object') {

            debugValueChange && console.log("yes... value really changed - USER ACTION");

            // @ts-ignore
            this.model[fieldId] = newValue

            // run onUserChange
            // if (this.fields[fieldId].onUserChange) {
            //     this.fields[fieldId].onUserChange.call(this, currentValue, newValue, this, fieldId); // last this = reference to form
            // }

            this.validate()
            this.renderErrors()

            // Now call callbacks
            if (this.onFieldChangedCallbacks[fieldId]) {
                this.onFieldChangedCallbacks[fieldId](newValue, fieldId)
            }

            if (!this.isFormChanged) this.formChanged();

        } else {
            debugValueChange &&  console.log("NO - value didnt' change it's just render of form...");
        }
    }

    public onSubmitClick(submitParams: any = {}) {

        debugSubmit && console.log("onSubmitClick()")

        // sometimes we want to double check all is good I guess...
        // like with file uploads for example
        this.validate()
        // if (this.validateBeforeSubmit) {
        //     debugValidation && console.log(".validateBeforeSubmit()")
        //     this.validateFields()
        //     this.validateForm()
        // }

        if (this.isFormValid) {

            debugSubmit && console.log("  Form is valid")

            this.displayErrors = false;
            this.isSubmitting = true;
            this.renderSubmitButton();

            if (this.onSubmit) {
                debugSubmit && console.log("    call onSubmit()", this.model)
                this.onSubmit(this.model, submitParams)
            }


        } else {

            debugSubmit && console.log("form is not valid... we should show errors", this.errors);

            this.displayErrors  = true;
            this.renderErrors()

            // // force all errors to render...
            // _.forEach(this.fields, function (field, name) {
            //     if (!field.isValid && field.error && field.errorComponent) {
            //         field.errorComponent.forceUpdate();
            //     }
            // })

        }
    }

    public onFieldChanged(fieldId:string, callback:callback) {
        this.onFieldChangedCallbacks[fieldId] = callback
    }


    // VALIDATIONS

    get isFormValid():boolean {
        // console.log("isFormValid()", !this.errors)
        return !this.errors
    }

    // RENDERS

    private renderErrors():void {

        debugErrors && console.log("renderErrors()")

        if (!this.displayErrors) {
            debugErrors && console.log("  displayErrors = false  ->  do nothing")
            return
        }

        // we need reset erros if none
        // if (!this.errors) {
        //     debugErrors && console.log("  no errors found ->  do nothing")
        //     return
        // }

        // problem we need remove old errors
        // so we set new errors and then fields we didn't touch -> reset error
        const fieldsWithErrors : string[] = []

        _.map(this.errors, (error)=>{

            // console.log("show error", error)

            switch (error.type) {
                case ErrorType.FieldIncorrectValue:
                case ErrorType.FieldRequired: {

                    const fieldId : string = (error as ErrorFieldRequired).field.fieldId
                    const errorComponent:FormFieldError = this.errorComponents[fieldId]

                    if (errorComponent) {
                        errorComponent.setError(error)
                        fieldsWithErrors.push(fieldId)
                    } else {
                        console.error("no error component -> need general error ", fieldId, this.errorComponents)
                    }


                }


                    break

                default:
                    console.error("unknonw error type #9d8kkmm")
                    break
            }



        })


        // now reset errors for fields that have no errors
        _.forEach(this.errorComponents, (errorComponent, fieldId)=>{

            if (!fieldsWithErrors.includes(fieldId)) {
                errorComponent.resetError()
            }

        })


    }

    private renderSubmitButton():void {
        if (this.submitButtonComponent) this.submitButtonComponent.forceUpdate();
        else {
            if (debug) console.warn(debug, "submitButtoncompaonent not found");
        }
    }




    _checkTrimmedEmpty(value:any) {
        return typeof value === "string" && value.trim() === '';
    }

    isFieldValid(field:any) {
        // if (debug.fieldValidation) console.groupCollapsed("validateField "+field.label);
        //
        // let isValid = true;
        // let error = null;
        //
        // // check if required
        // if (field.isRequired) {
        //     switch (field.type) {
        //         case 'checkbox':
        //             // do nothing... field vsegda tam. esli nuzno chto bi bil checked - well custom validation needed
        //             break;
        //         case 'select':
        //             if (field.value === undefined || field.value === null || this._checkTrimmedEmpty(field.value)) {
        //                 isValid = false;
        //                 error = field.label + " is required";
        //             }
        //             break;
        //         case 'input':
        //             if (!field.value || this._checkTrimmedEmpty(field.value)) {
        //                 isValid = false;
        //                 error = field.label + " is required";
        //             }
        //             break;
        //         case 'file':
        //             if (!field.value || this._checkTrimmedEmpty(field.value)) {
        //                 isValid = false;
        //                 error = field.label + " is required";
        //             }
        //             break;
        //         default:
        //             console.error(debug.head, ".validateField - unknown type " + field.type, field);
        //             break;
        //     }
        // }
        //
        // // check custom validaton
        // if (isValid && field.validator) {
        //     const validatorResult = field.validator.call(this, field.value, this); // added 2nd param
        //     if (validatorResult !== true) {
        //         isValid = false;
        //         error = validatorResult;
        //     }
        // }
        //
        // field.error = error;
        //
        // if (debug.fieldValidation) console.log("    valid=",isValid);
        // if (debug.fieldValidation) console.groupEnd();
        //
        // return isValid;

    }

    validateField(name:string, options:any={}) {

        console.log("not implemented $3d90asdasd", name, options)

        // if (debug.validation) console.log("validate field", name);
        //
        // const field = this.fields[name];
        //
        // const oldIsValid = this.fields[name].isValid;
        // const oldErrorMessage = this.fields[name].error;
        // const newIsValid = this.isFieldValid(field);
        // const newErrorMessage = this.fields[name].error;
        //
        // if (newIsValid !== oldIsValid) {
        //
        //     if (newIsValid) field.error = null; //remove validation error
        //     if ((!options || !options.silent) &&
        //         this.displayErrors && field.errorComponent)
        //         field.errorComponent.forceUpdate();
        //
        //     field.isValid = newIsValid;
        //     this.validateForm(options);
        //
        // } else if (oldErrorMessage !== newErrorMessage) {
        //     if ((!options || !options.silent) &&
        //         this.displayErrors && field.errorComponent)
        //         field.errorComponent.forceUpdate();
        // }
    }

    // setFieldIsRequired(name:string, newIsRequired:boolean) {
    //
    //     if (newIsRequired == this.fields[name].isRequired) return;
    //
    //     this.fields[name].isRequired = newIsRequired;
    //     this.validateField(name);
    // }

    // isFieldRequired(name:string) {
    //     return this.fields[name].isRequired;
    // }

    setFieldValue(name:string, value:any, options:any) {

        // if (debug.change) console.log(debug.head, 'setFieldValue', name, value, options);

        this.fields[name].value = value;
        this.validateField(name, options);

        //well we can go to on form component value change and trigger related on change... for now let's not do it'
    }

    setError(name:string, errorValue:any) {
        //this.errorComponents[name].forceUpdate();
    }





    setFormFieldCustomError(fieldName:string, errorMessage:any) {

        const field = this.fields[fieldName];

        field.isValid = false;
        field.error = errorMessage;

        this.displayErrors = true;

        field.errorComponent.forceUpdate();
    }


};
